import(/* webpackMode: "eager" */ "/codebuild/output/src2613691020/src/next-app/app/global-error.tsx");
